module.exports = __webpack_public_path__ + "img/bg_swiper.438fea2d.png";